export default 'M15.33.47c.43.12.45.71.05.92a12 12 0 0 0 0 21.22c.4.2.38.8-.05.92a12 12 0 1 1 0-23.06';